import { Minus, Plus, Trash2 } from "lucide-react";
import { triggerLightHaptic } from "../lib/haptics";

export default function ProductQuantityControl({
  quantity,
  onDecrease,
  onIncrease,
  placement = "inline",
  variant = "",
  forceExpanded = false,
  increaseDisabled = false,
  containerTestId,
  decreaseTestId,
  increaseTestId,
  quantityTestId,
  deleteIconTestId,
  minusIconTestId,
  increaseLabel = "زيادة الكمية",
  decreaseLabel = "تقليل الكمية",
  plusStrokeWidth = 2,
}) {
  const isExpanded = forceExpanded || quantity > 0;
  const isSingleItem = quantity === 1;

  const handleDecrease = (event) => {
    triggerLightHaptic();
    onDecrease(event);
  };

  const handleIncrease = (event) => {
    triggerLightHaptic();
    onIncrease(event);
  };

  return (
    <div
      className={[
        "product-list-quantity",
        `product-list-quantity--${placement}`,
        variant ? `product-list-quantity--${variant}` : "",
        isExpanded ? "is-expanded" : "",
      ].filter(Boolean).join(" ")}
      data-testid={containerTestId}
      dir="ltr"
    >
      {isExpanded && (
        <button
          type="button"
          onClick={handleDecrease}
          className="product-list-quantity-minus product-list-quantity-button"
          data-testid={decreaseTestId}
          aria-label={isSingleItem ? "حذف من السلة" : decreaseLabel}
        >
          {isSingleItem ? (
            <Trash2
              size={15}
              className="animate-in fade-in zoom-in-75 duration-200 text-red-500"
              data-testid={deleteIconTestId}
            />
          ) : (
            <Minus
              size={15}
              className="animate-in fade-in zoom-in-75 duration-200"
              data-testid={minusIconTestId}
            />
          )}
        </button>
      )}
      {isExpanded && (
        <span className="product-list-quantity-count num-badge" data-testid={quantityTestId}>
          {quantity}
        </span>
      )}
      <button
        type="button"
        onClick={handleIncrease}
        disabled={increaseDisabled}
        className="product-list-quantity-plus product-list-quantity-button disabled:opacity-40"
        data-testid={increaseTestId}
        aria-label={increaseLabel}
      >
        <Plus size={16} strokeWidth={plusStrokeWidth} />
      </button>
    </div>
  );
}